export enum StatusColor {
  'green',
  'yellow',
  'red',
}
